(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["p2g-progress-bar"] && !Shopify.designMode) return;
  try {
    (function() {
    function bindBars() {
      var bars = document.querySelectorAll('.p2g-cart-bar:not([data-p2g-bound])');
      bars.forEach(function(bar) {
        bar.setAttribute('data-p2g-bound', 'true');

        var tiers = [
          { cents: parseInt(bar.getAttribute('data-tier-1-cents'), 10) || 0, label: bar.getAttribute('data-tier-1-label') || '' },
          { cents: parseInt(bar.getAttribute('data-tier-2-cents'), 10) || 0, label: bar.getAttribute('data-tier-2-label') || '' },
          { cents: parseInt(bar.getAttribute('data-tier-3-cents'), 10) || 0, label: bar.getAttribute('data-tier-3-label') || '' },
          { cents: parseInt(bar.getAttribute('data-tier-4-cents'), 10) || 0, label: bar.getAttribute('data-tier-4-label') || '' }
        ];
        var msgProgress = bar.getAttribute('data-msg-progress') || '';
        var msgMaxed    = bar.getAttribute('data-msg-maxed') || '';
        var labelEl     = bar.querySelector('[data-p2g-cart="status-label"]');
        var fillEl      = bar.querySelector('[data-p2g-cart="fill"]');
        var tierEls     = bar.querySelectorAll('[data-tier-cents]');
        var maxCents    = tiers[tiers.length - 1].cents;

        function fmtMoney(cents) {
          return (cents / 100).toFixed(2).replace('.', ',') + ' $';
        }

        function update(totalCents) {
          if (!labelEl || !fillEl || maxCents <= 0) return;
          var pct = Math.min(100, (totalCents / maxCents) * 100);
          fillEl.style.width = pct + '%';
          tierEls.forEach(function(el) {
            var tc = parseInt(el.getAttribute('data-tier-cents'), 10) || 0;
            if (totalCents >= tc) el.classList.add('p2g-cart-bar__tier--unlocked');
            else el.classList.remove('p2g-cart-bar__tier--unlocked');
          });
          if (totalCents >= maxCents) {
            labelEl.textContent = msgMaxed;
            return;
          }
          var nextTier = null;
          for (var i = 0; i < tiers.length; i++) {
            if (totalCents < tiers[i].cents) { nextTier = tiers[i]; break; }
          }
          if (!nextTier) { labelEl.textContent = msgMaxed; return; }
          var remaining = Math.max(0, nextTier.cents - totalCents);
          labelEl.textContent = msgProgress
            .replace('[amount]', fmtMoney(remaining))
            .replace('[tier]', nextTier.label);
        }

        function refresh() {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(c) { update(c.total_price); })
            .catch(function() {});
        }

        document.addEventListener('cart:update', refresh);
      });
    }

    bindBars();
    document.addEventListener('DOMContentLoaded', bindBars);
    document.addEventListener('shopify:section:load', bindBars);
  })();
  } catch(e) { console.error(e); }
})();

})();
